var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/~/lodash/_getPrototype.js
// module id = 701
// module chunks = 4